import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Aditivi',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfam K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucraloză',
    [ProductAdditives.Aesculin]: 'Esculin',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Antocianină',
    [ProductAdditives.Antioxidant]: 'Antioxidant',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidant: acid ascorbic',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidant: tocoferoli',
    [ProductAdditives.Flavor]: 'Aromă',
    [ProductAdditives.Flavors]: 'Arome',
    [ProductAdditives.AscorbicAcid]: 'Acid ascorbic',
    [ProductAdditives.Aspartame]: 'Aspartam',
    [ProductAdditives.OysterSauce]: 'Sos de stridii',
    [ProductAdditives.BakingAid]: 'Agent de coacere',
    [ProductAdditives.BakingPowder]: 'Praf de copt',
    [ProductAdditives.BalsamicVinegar]: 'Oțet balsamic',
    [ProductAdditives.BalsamicCream]: 'Cremă balsamică',
    [ProductAdditives.BasilPesto]: 'Pesto de busuioc',
    [ProductAdditives.BenzoicAcid]: 'Acid benzoic',
    [ProductAdditives.BetaCarotene]: 'Beta-caroten',
    [ProductAdditives.Betain]: 'Betaină',
    [ProductAdditives.BeetrootRed]: 'Roșu de sfeclă',
    [ProductAdditives.Beeswax]: 'Ceară de albine',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Sirop Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Oțet de brandy',
    [ProductAdditives.Broth]: 'Supă',
    [ProductAdditives.Caffeine]: 'Cafeină',
    [ProductAdditives.Calcium]: 'Calciu',
    [ProductAdditives.Caramel]: 'Caramel',
    [ProductAdditives.CaramelColor]: 'Colorant caramel',
    [ProductAdditives.CaramelE150d]: 'Caramel E150d',
    [ProductAdditives.Carotene]: 'Caroten',
    [ProductAdditives.CayennePepper]: 'Piper cayenne',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Dressing chili',
    [ProductAdditives.ChiliMayonnaise]: 'Maioneză chili',
    [ProductAdditives.ChiliOil]: 'Ulei de chili',
    [ProductAdditives.Quinine]: 'Chinină',
    [ProductAdditives.Chlorophyll]: 'Clorofilă',
    [ProductAdditives.CitricAcid]: 'Acid citric',
    [ProductAdditives.CitrusAcid]: 'Acid din citrice',
    [ProductAdditives.CarbonDioxide]: 'Dioxid de carbon (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Sos cocktail',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Pastă curry',
    [ProductAdditives.CurryPowder]: 'Pudră curry',
    [ProductAdditives.CurryCreamSauce]: 'Sos cremă curry',
    [ProductAdditives.Fragrance]: 'Parfum',
  },
};
